import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faTruckPickup, faTruckMoving, faStore, faHome } from '@fortawesome/free-solid-svg-icons';

// Homepage product spotlights (STATIC, code-managed). Data-driven, alternating
// image/content layout with alternating background bands. Replaced the legacy
// HomeF3 First/Second/Third sub-components (now unused).
const SPOTLIGHTS = [
    {
        icon: faCar,
        heading: "Auto Insurance Quotes",
        subheading: "Looking for affordable auto insurance in California?",
        paras: [
            "GM Insurance Services helps California drivers compare auto insurance quotes from multiple insurance carriers. Whether you are buying a car, switching insurance companies, adding a driver, or reviewing your current policy, our team can help you explore coverage options that fit your needs and budget.",
            "We can help with liability insurance, full coverage auto insurance, uninsured motorist coverage, comprehensive and collision coverage, and other available options for California drivers.",
        ],
        quoteTo: "/auto-insurance-form",
        learnTo: "/auto-insurance-quote",
    },
    {
        icon: faTruckPickup,
        heading: "Commercial Auto Insurance Quotes",
        subheading: "Need affordable commercial auto insurance for your business?",
        paras: [
            "GM Insurance Services helps California business owners compare commercial auto insurance quotes for work vehicles, business cars, vans, trucks, and fleets. Whether you are a contractor, service business, delivery operation, or small business with company vehicles, we can help you find coverage options based on your vehicle use and business needs.",
            "Commercial auto insurance may help protect your business from accidents, liability claims, vehicle damage, and other risks involving vehicles used for business.",
        ],
        quoteTo: "/commercial-auto-insurance-form",
        learnTo: "/commercial-auto-insurance",
    },
    {
        icon: faTruckMoving,
        heading: "Trucking Insurance Quotes",
        subheading: "Insurance options for box trucks, owner-operators, and fleets",
        paras: [
            "GM Insurance Services helps trucking businesses compare insurance options for box trucks, semi-trucks, hot shot operations, and commercial fleets. We can help review coverage needs such as liability, physical damage, motor truck cargo, trailer interchange, filings, and other available trucking insurance options.",
            "Whether you operate one truck or manage multiple vehicles, our team can help you request a quote and review coverage options for your operation.",
        ],
        quoteTo: "/trucking-insurance-quote",
        learnTo: "/trucking-insurance",
    },
    {
        icon: faStore,
        heading: "Business Insurance Quotes",
        subheading: "Protect your business with the right coverage",
        paras: [
            "GM Insurance Services helps California businesses compare insurance options for general liability, business owner's policy, commercial property, workers compensation, and other business insurance needs.",
            "Whether you are a contractor, service provider, office, retail business, or growing company, we can help you review coverage options designed to protect your business from common risks, including property damage, customer injury claims, employee injuries, and business liability.",
        ],
        quoteTo: "/business-insurance-quote",
        learnTo: "/business-insurance",
    },
    {
        icon: faHome,
        heading: "Homeowners & Earthquake Insurance",
        subheading: "Coverage options for California homeowners",
        paras: [
            "GM Insurance Services helps California homeowners compare homeowners insurance options from available carriers. Whether you are buying a home, switching insurance companies, or reviewing your current policy, our team can help you look for coverage for your home, personal property, and liability needs.",
            "We can also help eligible California homeowners review earthquake insurance options for damage that standard homeowners insurance usually does not cover.",
        ],
        quoteTo: "/home-owner-insurance-form",
        learnTo: "/earthquake-insurance",
    },
];

const HomeF3 = React.memo(() => {
    return (
        <div className="home-spots">
            <style>{`
                .home-spot{width:100vw;margin-left:-15px;padding:54px 24px;background:#fff;}
                .home-spot.alt{background:#f4f7fb;}
                .home-spot__inner{max-width:1080px;margin:0 auto;display:flex;flex-wrap:wrap;align-items:center;gap:44px;}
                .home-spot.alt .home-spot__inner{flex-direction:row-reverse;}
                .home-spot__icon{flex:1 1 220px;display:flex;justify-content:center;}
                .home-spot__icon svg{font-size:118px;color:#1b75bc;}
                .home-spot__body{flex:1 1 440px;}
                .home-spot__body h2{font-size:1.85rem;font-weight:700;color:#132042;margin:0;line-height:1.25;}
                .home-spot__dash{width:5em;height:.45em;background:#f03d3d;border-radius:2px;margin:14px 0 16px;}
                .home-spot__sub{font-size:1.08rem;font-weight:600;color:#1b75bc;margin:0 0 12px;}
                .home-spot__body p:not(.home-spot__sub){font-size:.94rem;color:#42526b;line-height:1.7;margin:0 0 12px;}
                .home-spot__btns{display:flex;flex-wrap:wrap;gap:14px;margin-top:8px;}
                @media(max-width:768px){
                    .home-spot__inner,.home-spot.alt .home-spot__inner{flex-direction:column;text-align:center;gap:18px;}
                    .home-spot__dash{margin-left:auto;margin-right:auto;}
                    .home-spot__btns{justify-content:center;}
                    .home-spot__icon svg{font-size:84px;}
                }
            `}</style>
            {SPOTLIGHTS.map((s, i) => (
                <section key={s.heading} className={`home-spot${i % 2 ? " alt" : ""}`}>
                    <div className="home-spot__inner">
                        <div className="home-spot__icon">
                            <FontAwesomeIcon icon={s.icon} />
                        </div>
                        <div className="home-spot__body">
                            <h2>{s.heading}</h2>
                            <div className="home-spot__dash" />
                            <p className="home-spot__sub">{s.subheading}</p>
                            {s.paras.map((p, j) => <p key={j}>{p}</p>)}
                            <div className="home-spot__btns">
                                <Link to={s.quoteTo}>
                                    <button type="button" className="btn btn-raised btn-success btn-gm-green btn-home-radius">Get a Free Quote</button>
                                </Link>
                                <Link to={s.learnTo}>
                                    <button type="button" className="btn btn-outline-success btn-gm-outline-green btn-home-radius">Learn More</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            ))}
        </div>
    );
});

export default HomeF3;
